import React from "react";
export default function RAND() {
  return <div>Excel_RAND</div>;
}
